/* eslint no-undef: 0 */
/* eslint no-unused-vars: 0 */
/* eslint default-case: 0 */
import React, { Component } from 'react';
import { string, func } from 'prop-types';
import { isFunction } from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';
import { generateClientToken } from '../api';
import {
    FIVERR_LOCALE_TO_PAYPAL_LOCALE,
    LEARN_MORE_DEFAULT_STYLE,
    LEARN_MORE_DRAWER_STYLE,
    LEARN_MORE_SIDEBAR_CONTENT_STYLE,
    PAYPAL_DEFAULT_LOCALE,
    PAYPAL_LEARN_MORE_STYLES,
    PAYPAL_LEARN_MORE_ELEMENT,
} from '../consts';

i18n.add(require('../../copies.json'));

export class PaypalMessageBase extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
        };

        this.generatePaypalButton = this.generatePaypalButton.bind(this);
        this.generate = this.generate.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onMount = this.onMount.bind(this);
        this.onCompleteRender = this.onCompleteRender.bind(this);
        this.renderPaypalMessage = this.renderPaypalMessage.bind(this);
    }

    componentDidMount() {
        const { onLoad } = this.props;
        this.onMount();
        onLoad(this.generate, this.onCancel);
    }

    async generate() {
        const { paymentOptionId } = this.props;
        let { clientToken } = this.props;

        if (clientToken) {
            await this.generatePaypalButton(clientToken);
        } else if (paymentOptionId) {
            clientToken = await generateClientToken(paymentOptionId);
            await this.generatePaypalButton(clientToken);
        }
    }

    async generatePaypalButton(clientToken) {
        try {
            const clientInstance = await braintree.client.create({
                authorization: clientToken,
            });

            const paypalCheckoutInstance = await braintree.paypalCheckout.create({
                client: clientInstance,
            });

            await paypalCheckoutInstance.loadPayPalSDK({
                components: 'messages',
                locale: this.fetchLocale(),
                dataAttributes: this.resolveDataAttributes(),
            });

            await this.renderPaypalMessage();
        } catch (error) {
            this.onCancel();
        }
    }

    async renderPaypalMessage() {
        try {
            const paypalConfigs = {
                style: this.resolvePaypalStyle(),
                onClick: this.onClick,
            };

            await this.resolveDataNamespace()
                .Messages(paypalConfigs)
                .render(`#${PAYPAL_LEARN_MORE_ELEMENT}-${this.props.paypalStyle}`);

            this.onCompleteRender();
        } catch (error) {
            this.onCancel();
        }
    }

    resolvePaypalStyle() {
        const { paypalStyle } = this.props;

        switch (paypalStyle) {
            case PAYPAL_LEARN_MORE_STYLES.LEFT:
                return LEARN_MORE_SIDEBAR_CONTENT_STYLE;
            case PAYPAL_LEARN_MORE_STYLES.CENTER:
                return LEARN_MORE_DRAWER_STYLE;
            default:
                return LEARN_MORE_DEFAULT_STYLE;
        }
    }

    resolveDataAttributes() {
        const { paypalStyle } = this.props;

        switch (paypalStyle) {
            case PAYPAL_LEARN_MORE_STYLES.LEFT:
                return { 'data-namespace': 'paypal_left' };
            case PAYPAL_LEARN_MORE_STYLES.CENTER:
                return { 'data-namespace': 'paypal_center' };
            default:
                return { 'data-namespace': 'paypal' };
        }
    }

    resolveDataNamespace() {
        const { paypalStyle } = this.props;

        switch (paypalStyle) {
            case PAYPAL_LEARN_MORE_STYLES.LEFT:
                return paypal_left;
            case PAYPAL_LEARN_MORE_STYLES.CENTER:
                return paypal_center;
            default:
                return paypal;
        }
    }

    onCancel() {
        if (isFunction(this.props.onCancel)) {
            this.props.onCancel();
        }
    }

    onMount() {
        if (isFunction(this.props.onMount)) {
            this.props.onMount();
        }
        this.setState({ loading: true });
    }

    onClick() {
        if (isFunction(this.props.onClick)) {
            this.props.onClick();
        }
    }

    onCompleteRender() {
        if (isFunction(this.props.onCompleteRender)) {
            this.props.onCompleteRender();
        }
        this.setState({ loading: false });
    }

    fetchLocale() {
        const { locale } = getContext();
        return FIVERR_LOCALE_TO_PAYPAL_LOCALE[locale] || PAYPAL_DEFAULT_LOCALE;
    }

    render() {
        return (
            <div className="paypal-message-container">
                <div id={`${PAYPAL_LEARN_MORE_ELEMENT}-${this.props.paypalStyle}`} />
            </div>
        );
    }
}

PaypalMessageBase.propTypes = {
    clientToken: string,
    paypalStyle: string,
    onCancel: func,
    onMount: func,
    onCompleteRender: func,
    onLoad: func,
    paymentOptionId: string,
    onClick: func,
};
